module.exports = " <div class=micro> <v-head></v-head> <div class=micro_ul> {{{micro_str}}} </div> <v-footer></v-footer> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/micro/micro.vue
// module id = 65
// module chunks = 1